/** 初始化环境变量 */
export const INIT_ENV = 'INIT_ENV';

/** 缓存车费查询结果 */
export const QUERY_RESULT = 'QUERY_RESULT';

/** 缓存用户优惠券列表 */
export const COUPON_LIST = 'COUPON_LIST';

/** 缓存车场详情 */
export const PARK_DETAIL = 'PARK_DETAIL';

/** 客户端 */
export const USER_AGENT = 'USER_AGENT';

/** 缓存用户当前可用线上券 */
export const USABLE_REBATE = 'USABLE_REBATE';

/** 缓存用户当前可用线下券 */
export const USABLE_COUPON = 'USABLE_COUPON';

/** 缓存用户当前选中优惠券 */
export const PICK_COUPON = 'PICK_COUPON';

/** 支付倒计时 */
export const SET_COUNTDOWN = 'SET_COUNTDOWN';

/** 限制车场 */
export const LIMIT_PARK = 'LIMIT_PARK';

/** 广告禁投车场名单（payadmin 下发，-1=全部车场；null=未加载完成） */
export const DISABLED_ADVERT_PARKS = 'DISABLED_ADVERT_PARKS';

/** 出口码解析出的车场ID（plate=rryb-{parkId}-{设备号}，非出口码为 null） */
export const ADVERT_EXIT_PARK = 'ADVERT_EXIT_PARK';

/** 用户开通免密支付 */
export const USER_IS_OPEN_PAY_NO_PASSWORD = 'USER_IS_OPEN_PAY_NO_PASSWORD';
